import { HubPackageDeploymentStatus } from "@models";
import { CheckCircle2, CircleDashed, XCircle } from "lucide-react";

export function resolveHubPackageDeploymentStatusBadge(status?: string) {
  switch (status?.toLowerCase()) {
    case HubPackageDeploymentStatus.INSTALLED:
      return {
        label: "Installed",
        variant: "success" as const,
        icon: CheckCircle2,
      };
    case HubPackageDeploymentStatus.FAILED:
      return {
        label: "Failed",
        variant: "destructive" as const,
        icon: XCircle,
      };
    case HubPackageDeploymentStatus.PENDING:
      return {
        label: "Pending",
        variant: "warning" as const,
        icon: CircleDashed,
      };
    default:
      return {
        label: status || "Unknown",
        variant: "secondary" as const,
        icon: CircleDashed,
      };
  }
}
